import React from 'react';
import PropTypes from 'prop-types';

import { Label }from 'semantic-ui-react';

// Enumeration of environments supported by this label
//
// Environments outside of this enum will be rendered verbatim in a grey label, 
// and a warning will be emitted to the console.
export const Environment = Object.freeze({
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOP: 'develop',
});


// Mapping from runime environment to label color
//
// If the environment is not present in the map, it will be rendered as grey.
const COLOR_MAP = {
  [Environment.STAGING]: 'blue',
  [Environment.DEVELOP]: 'green',
};


/**
 * Indicator label for the current environment
 *
 * If the the env prop is 'production', the label is not rendered.
 * The labels for 'staging' and 'develop' are blue and green respectively.
 * For any other env the label will be grey.
 */
const EnvLabel = (props) => { 
  const { env } = props;
  const color = COLOR_MAP[env] || 'grey';
  return (
    env === Environment.PRODUCTION
    ? null
    : <Label basic color={color}>{env}</Label>
  )
};

export default EnvLabel;

EnvLabel.propTypes = {
  /** Runtime environment */
  env: PropTypes.oneOf(Object.values(Environment)).isRequired,
};
